import { render } from "./InnerPage.vue?vue&type=template&id=2c9c6d49&scoped=true"
import script from "./InnerPage.vue?vue&type=script&lang=js"
export * from "./InnerPage.vue?vue&type=script&lang=js"

import "./InnerPage.vue?vue&type=style&index=0&id=2c9c6d49&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9c6d49"]])

export default __exports__